import { WindowSize } from 'hooks/useResize';

export const MIN_SCALE_FACTOR = 0.9;
export const ZOOM_FACTOR = 20;
export const DEBOUNCE_TIME = 200;
export const FOOTER_HEIGHT = 56;

export const BRUSH_RADIUS = 1;
export const BRUSH_COLOR = 'red';
export const LAZY_RADIUS = 2;

export function getDimensions(container: HTMLElement | null): WindowSize {
  const width = container?.offsetWidth || 0;
  const height = container?.offsetHeight || 0;

  return {
    width,
    height,
  };
}

export function fullyCleared(
  cleared: boolean,
  linesObject: boolean | number | { lines: any[] }
): boolean {
  return (
    cleared &&
    typeof linesObject === 'object' &&
    Array.isArray(linesObject.lines) &&
    !linesObject.lines.length
  );
}

export function getInitialScale(
  containerDimensions: WindowSize,
  imageDimensions: WindowSize
): number {
  if (
    !containerDimensions.width ||
    !containerDimensions.height ||
    !imageDimensions.width ||
    !imageDimensions.height
  ) {
    return 1;
  }

  return Math.min(
    containerDimensions.width / imageDimensions.width,
    containerDimensions.height / imageDimensions.height
  );
}
